import { IconButton, Tooltip } from "@material-ui/core";
import {
  Call,
  Circle,
  Group,
  Handshake,
  // Paid,
  Room,
} from "@mui/icons-material";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnCNPJCPFField } from "utils/tables-utils";
import { columnTextField } from "utils/tables-utils";

export default function TableCnpj({ data, onClick, selectedRow }) {
  const columnModel = [
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        const color = row.Status === "ATIVO" ? "success" : "error";
        return (
          <Tooltip title={row.Status || ""}>
            <Circle color={color} />
          </Tooltip>
        );
      },
    }),
    columnCNPJCPFField({
      dataField: "CNPJ",
      text: "CNPJ",
      headerStyle: { minWidth: "10vw" },
    }),
    columnTextField({
      dataField: "InscricaoEstadual",
      text: "Inscrição Estadual",
      align: "center",
      headerStyle: { minWidth: "10vw" },
    }),
    columnTextField({
      dataField: "CodigoFornecedor",
      text: "Cód Fornecedor",
      align: "center",
      headerStyle: { minWidth: "10vw" },
    }),
    columnTextField({
      dataField: "RazaoSocial",
      text: "Razão Social",
      align: "center",
      headerStyle: { minWidth: "30vw" },
    }),

    columnTextField({
      dataField: "contato",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Representantes">
            <IconButton
              color="primary"
              onClick={() => {
                onClick("REPRESENTANTE");
                selectedRow(row);
              }}
            >
              <Handshake />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "endereco",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Endereço">
            <IconButton
              color="primary"
              onClick={() => {
                onClick("ADDRESS");
                selectedRow(row);
              }}
            >
              <Room />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "meucontato",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Contatos">
            <IconButton
              color="primary"
              onClick={() => {
                onClick("CONTACT");
                selectedRow(row);
              }}
            >
              <Call />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "meusUsuarios",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Usuários">
            <IconButton
              color="primary"
              onClick={() => {
                onClick("USERS");
                selectedRow(row);
              }}
            >
              <Group />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    // columnTextField({
    //   dataField: "condicaoComercial",
    //   text: "",
    //   align: "center",
    //   formatter: (_, row) => {
    //     return (
    //       <Tooltip title="Condição Comercial">
    //         <IconButton
    //           color="primary"
    //           onClick={() => {
    //             onClick("COMERCIAL");
    //             selectedRow(row);
    //           }}
    //         >
    //           <Paid />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
  ];

  return (
    <ToolkitTable
      dataTable={data}
      searched={Boolean(data)}
      keyField={"Cnpj"}
      columnModel={columnModel}
      headerTitle="Minhas Empresas"
      showSearch
      notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
    />
  );
}
